import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod";
import { Form, FormField } from "src/Components/ui/form";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useEffect, useRef, useState } from "react";
import NotificationTabs from "../NotificationTabs";
import { SelectBoxForm } from "src/Components/selectbox/SelectBoxForm";
import { Button } from "src/Components/ui/button";
import { DialogClose } from "src/Components/ui/dialog";
import { IMG_URl } from "src/common/img_url";
import FormFieldItem from "src/common/form/FormFieldItem";
import ImageSelected from "src/Components/Uploaders/ImageSelected";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "src/Components/ui/card";
import { FileText, Image as ImageIcon } from "lucide-react";
function NotificationForm(props) {
  const [image, setImage] = useState("");
  const { t } = useTranslation();
  const dialogCloseRef = useRef(null);
  // make validation and form fields values conditionally
  const formSchema = z.object({
    title_ar: z
      .string({
        required_error: `${t("gloabl.title")} ${t(
          "errorMessage.fieldRequired"
        )}.`,
      })
      .min(2, {
        message: `${t("gloabl.title")} ${t("errorMessage.fieldCharsLength")}.`,
      }),
    title_en: z
      .string({
        required_error: `${t("gloabl.title")} ${t(
          "errorMessage.fieldRequired"
        )}.`,
      })
      .min(2, {
        message: `${t("gloabl.title")} ${t("errorMessage.fieldCharsLength")}.`,
      }),
    description_ar: z
      .string({
        required_error: `${t("gloabl.description")} ${t(
          "errorMessage.fieldRequired"
        )}.`,
      })
      .min(2, {
        message: `${t("gloabl.description")} ${t(
          "errorMessage.fieldCharsLength"
        )}.`,
      }),
    description_en: z
      .string({
        required_error: `${t("gloabl.description")} ${t(
          "errorMessage.fieldRequired"
        )}.`,
      })
      .min(2, {
        message: `${t("gloabl.description")} ${t(
          "errorMessage.fieldCharsLength"
        )}.`,
      }),

    image: z
      .union([
        z.instanceof(File).refine((file) => file.size < 4 * 1024 * 1024, {
          message: "File size must be less than 4MB",
          required_error: `${t("gloabl.image")} ${t(
            "errorMessage.fieldRequired"
          )}.`,
        }),
        z.string({
          required_error: `${t("gloabl.image")} ${t(
            "errorMessage.fieldRequired"
          )}.`,
        }),
      ])
      .optional(),
  });
  const [deleteImage, setDeleteImage] = useState(0);

  // 1. Define your form.
  const form = useForm({
    resolver: zodResolver(formSchema),

    defaultValues: {
      ...props.datasource,
      image: image,
    },
  });

  const onErorr = (errors) => {
    console.log(errors);

    toast.error(t("errorMessage.fillAll"));
  };

  const onSubmit = (values) => {
    const submitValues = {
      ...values,
      delete_image: deleteImage,
    };
    console.log(submitValues);

    props.onSubmit(submitValues);
    if (dialogCloseRef.current) {
      dialogCloseRef.current.click();
    }
  };

  useEffect(() => {
    if (props.editMode) {
      setImage(props.datasource.image ? IMG_URl + props.datasource.image : "");
    }
  }, [props.editMode]);

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit, onErorr)}
        className="space-y-6"
      >
        {/* Content Section */}
        <Card>
          <CardHeader className="bg-blue-50 dark:bg-blue-950/30 border-b">
            <CardTitle className="flex items-center gap-2">
              <FileText className="w-5 h-5 text-blue-600" />
              {t("gloabl.content") || "Content"}
            </CardTitle>
            <CardDescription>
              {t("gloabl.content_desc") || "Enter notification title and description in both languages"}
            </CardDescription>
          </CardHeader>
          <CardContent className="pt-6">
            <NotificationTabs form={form} />
          </CardContent>
        </Card>

        {/* Image Section */}
        <Card>
          <CardHeader className="bg-purple-50 dark:bg-purple-950/30 border-b">
            <CardTitle className="flex items-center gap-2">
              <ImageIcon className="w-5 h-5 text-purple-600" />
              {t("gloabl.image")}
            </CardTitle>
            <CardDescription>
              {t("gloabl.image_desc") || "Upload an image for your notification (optional but recommended)"}
            </CardDescription>
          </CardHeader>
          <CardContent className="pt-6">
            <FormField
              control={form.control}
              name="image"
              render={({ field }) => (
                <FormFieldItem form={form} label={t("gloabl.image")}>
                  <ImageSelected
                    form={form}
                    control={form.control}
                    name="image"
                    {...field}
                    editMode={props.editMode}
                    image={image}
                    setImage={setImage}
                    setDeleteImage={setDeleteImage}
                  />
                </FormFieldItem>
              )}
            />
          </CardContent>
        </Card>

        {/* Form Actions */}
        <div className="flex items-center justify-end gap-3 pt-4 border-t">
          <DialogClose asChild>
            <Button type="button" variant="outline" size="lg">
              {t("gloabl.cancel")}
            </Button>
          </DialogClose>
          <DialogClose ref={dialogCloseRef} />
          <Button type="submit" size="lg">
            {t("gloabl.save")}
          </Button>
        </div>
      </form>
    </Form>
  );
}

export default NotificationForm;
